import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { CompanyQueryKey } from './queryKey';
export const useCreateCompany = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base.post('/api/company/create', model).then(res => res.data), {
        onSuccess: (result) => {
            if (!result)
                return;
            queryClient.setQueryData([CompanyQueryKey.Companies], (old) => {
                if (!old)
                    return [result];
                return [...old, result];
            });
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { createCompany: mutateAsync, isCreating: isLoading };
};
